import React from 'react';
import { Link } from 'react-router-dom';

import '../styles/home.css';
import mb from '../assets/images/mb.png';

const Home = () => (
  <div class="home">
    <h1>Apps</h1>
    <div class="app-list">
        <div class="app-menu">
            <Link to='/mindfulbreathing'>
                <img alt="" src={mb}/>
                <div>Mindful Breathing</div>
            </Link>
        </div>
    </div>
  </div>
)

export default Home
